import { Dayjs } from 'dayjs'
import { request } from '../request'

export const pollution = {
  getPollution: function () {
    return request.get('pollution')
  },

  getPollutionPrediction: function (idExec: number, date: string) {
    return request.get(`pollution/predictions?id_exec=${idExec}&date=${date}`)
  },

  getPollutionLayerURL: function (
    idVariable: string,
    date: Dayjs,
    dateExec: string,
    mapType: 'gfs' | 'pred',
    neuron?: string
  ) {
    let url = `pollution/map?variable=${idVariable}&date=${date}&date_exec=${dateExec}&type_map=${mapType}`

    if (neuron) {
      url += `&neuron=${neuron}`
    }
    return url
  }
}
